import { LayoutSpinner } from '@/bundle/Layouts/styles';
import { AuthLayout } from '@/bundle/Auth/ui/AuthLayout/AuthLayout';
import { useMutation } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { getLoginPath } from '../../LoginFlow/LoginPage/path/path';
import { getResponseError } from '@/helpers/apiHelpers/responseHelpers';
import { ACTIVATION_TOKEN_INVALID_RESPONSE, ONBOARDING_USER_ALREADY_EXISTS } from '@/api/const';
import { setEmailConfirmation } from './api';
import { getEmailConfirmationLinkExpiredPath } from '../../pages/EmailConfirmationExpiredPage/path';
import { useAuthNavigateToStep } from '@/bundle/Auth/hooks/useAuthNavigateToStep';
import { showSnackbarResponseError } from '@/helpers/helpers';

type EmailConfirmationValidateTotpPayload = { userId: string; token: string };

export const EmailConfirmationValidateTotpPage = () => {
  const navigateToStep = useAuthNavigateToStep();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [isValidatingTotp, setIsValidatingTotp] = useState(true);

  const { mutate } = useMutation({
    mutationKey: ['set_email_confirmation'],
    mutationFn: (payload: EmailConfirmationValidateTotpPayload) => {
      const { userId, token } = payload;

      return setEmailConfirmation(userId, token);
    },
    onSuccess(response) {
      if (response?.error) {
        const errorContent = getResponseError(response?.error);

        if (errorContent === ONBOARDING_USER_ALREADY_EXISTS) {
          return navigate(getLoginPath(), { state: { recipientAccountsExists: true } });
        }

        if (errorContent === ACTIVATION_TOKEN_INVALID_RESPONSE) {
          return navigate(getEmailConfirmationLinkExpiredPath());
        }

        return showSnackbarResponseError(response?.error);
      }

      navigateToStep(response?.body);
    },
    onSettled: () => {
      setIsValidatingTotp(false);
    },
  });

  useEffect(() => {
    const token = searchParams.get('token');
    const userId = searchParams.get('user_id');

    if (!token || !userId) {
      navigate(getLoginPath());

      return;
    }

    const payload = { token, userId };

    mutate(payload);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <AuthLayout>{isValidatingTotp && <LayoutSpinner />}</AuthLayout>;
};
